import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { forwardRef } from 'react';

const IconButtonWrapper = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => (
  <IconButton ref={ref} {...props} />
));

export default IconButtonWrapper;
